module.exports = __webpack_public_path__ + "uarm-images/one-back.svg";